// this export is icon files w/o the js extension; include icon names in this export if an icon should be rendered in the display page under the Indicators category

let icons = ['Capped', 'Deduplicated', 'Group', 'NullReport']

export default icons
